import { useEffect, useState } from 'react'

export default function useHasVisibleScrollBar() {
  const [hasVisibleScrollBar, setHasVisibleScrollBar] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      if (!document.documentElement.classList.contains('scrollbar')) {
        setHasVisibleScrollBar(false)
      }
    }, 10)
  }, [])

  return hasVisibleScrollBar
}
